import { FC, RefObject, useCallback } from 'react';
import { useFormContext } from 'react-hook-form';

import { RecaptchaHandle } from '@mopla/ui';

import { environment } from '../../../environments/environment';

import { StyledRecaptcha } from './DTicketSubscription.styles';
import { ISubscriptionFormValues } from './types';

interface IDTicketSubscriptionRecaptchaProps {
	recaptchaRef: RefObject<RecaptchaHandle>;
}

export const DTicketSubscriptionRecaptcha: FC<
	IDTicketSubscriptionRecaptchaProps
> = ({ recaptchaRef }) => {
	const { setError, setValue } = useFormContext<ISubscriptionFormValues>();

	const handleRecaptchaVerify = useCallback(
		(token: string) => {
			// Store the token in the form data
			setValue('recaptchaToken', token);
		},
		[setValue]
	);

	const handleRecaptchaError = useCallback(() => {
		console.error('reCAPTCHA error');
		// Handle reCAPTCHA error
		setError('serverError', {
			message: 'captcha.error',
		});
	}, [setError]);

	const handleRecaptchaExpired = useCallback(() => {
		console.warn('reCAPTCHA expired');
		// Handle reCAPTCHA expiration
		if (recaptchaRef.current) {
			recaptchaRef.current.resetRecaptcha();
			setValue('recaptchaToken', undefined);
		}
	}, [setValue]);

	return (
		<StyledRecaptcha
			ref={recaptchaRef}
			siteKey={environment.recaptchaSiteKey}
			onVerify={handleRecaptchaVerify}
			onError={handleRecaptchaError}
			onExpired={handleRecaptchaExpired}
			invisible
		/>
	);
};
